/**
 * Check if typeof value is number and it isn't NaN
 * @param {*} value
 */
const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value);

export default isNumber;
